import {Injectable} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import ltLocale from '@angular/common/locales/lt';
import enLocale from '@angular/common/locales/en';
import ruLocale from '@angular/common/locales/ru';
import deLocale from '@angular/common/locales/de';
import plLocale from '@angular/common/locales/pl';
import frLocale from '@angular/common/locales/fr';
import lvLocale from '@angular/common/locales/lv';
import czLocale from '@angular/common/locales/cs';
import esLocale from '@angular/common/locales/es';
import roLocale from '@angular/common/locales/ro';
import itLocale from '@angular/common/locales/it';
import ukLocale from '@angular/common/locales/uk';
import huLocale from '@angular/common/locales/hu';
import bgLocale from '@angular/common/locales/bg';
import skLocale from '@angular/common/locales/sk';
import ptLocale from '@angular/common/locales/pt';
import hrLocale from '@angular/common/locales/hr';
import trLocale from '@angular/common/locales/tr';
import nlLocale from '@angular/common/locales/nl';
import srLocale from '@angular/common/locales/sr';
import slLocale from '@angular/common/locales/sl';
import {DAYS_OF_WEEK} from 'angular-calendar';

let moment = require('moment-timezone');

@Injectable()
export class LocaleService {

  constructor() {
  }

  public loadLocale(lang: string): void {
    switch (lang) {
      case 'lt':
        registerLocaleData(ltLocale);
        this.updateMomentLocale('lt')
        break;
      case 'ru':
        registerLocaleData(ruLocale);
        this.updateMomentLocale('ru')
        break;
      case 'de':
        registerLocaleData(deLocale);
        this.updateMomentLocale('de')
        break;
      case 'pl':
        registerLocaleData(plLocale);
        this.updateMomentLocale('pl')
        break;
      case 'fr':
        registerLocaleData(frLocale);
        this.updateMomentLocale('fr')
        break;
      case 'lv':
        registerLocaleData(lvLocale);
        this.updateMomentLocale('lv')
        break;
      case 'cz':
        registerLocaleData(czLocale);
        this.updateMomentLocale('cz')
        break;
      case 'es':
        registerLocaleData(esLocale);
        this.updateMomentLocale('es')
        break;
      case 'ro':
        registerLocaleData(roLocale);
        this.updateMomentLocale('ro')
        break;
      case 'it':
        registerLocaleData(itLocale);
        this.updateMomentLocale('it')
        break;
      case 'uk':
        registerLocaleData(ukLocale);
        this.updateMomentLocale('uk')
        break;
      case 'hu':
        registerLocaleData(huLocale);
        this.updateMomentLocale('hu')
        break;
      case 'bg':
        registerLocaleData(bgLocale);
        this.updateMomentLocale('bg')
        break;
      case 'sk':
        registerLocaleData(skLocale);
        this.updateMomentLocale('sk')
        break;
      case 'pt':
        registerLocaleData(ptLocale);
        this.updateMomentLocale('pt')
        break;
      case 'hr':
        registerLocaleData(hrLocale);
        this.updateMomentLocale('hr')
        break;
      case 'tr':
        registerLocaleData(trLocale);
        this.updateMomentLocale('tr')
        break;
      case 'nl':
        registerLocaleData(nlLocale);
        this.updateMomentLocale('nl')
        break;
      case 'sr':
        registerLocaleData(srLocale);
        this.updateMomentLocale('sr')
        break;
      case 'sl':
        registerLocaleData(slLocale);
        this.updateMomentLocale('sl')
        break;
      case 'en':
      default:
        registerLocaleData(enLocale);
        this.updateMomentLocale('en')
        break;
    }
  }

  public setDefaultTimezone(timezone: string): void {
    if (timezone != null) {
      moment.tz.setDefault(timezone);
    }
  }

  private updateMomentLocale(lang: string): void {
    moment.updateLocale(lang, {
      week: {
        dow: DAYS_OF_WEEK.MONDAY,
        doy: 0
      }
    })
  }

}
